import * as React from "react"
const ViewIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#2FD4CF"
        d="M9.783 4.5c-3.068 0-5.688 1.866-6.75 4.5 1.062 2.634 3.682 4.5 6.75 4.5s5.689-1.866 6.75-4.5c-1.061-2.634-3.682-4.5-6.75-4.5Zm0 7.5c-1.693 0-3.068-1.344-3.068-3S8.09 6 9.783 6c1.694 0 3.068 1.344 3.068 3s-1.374 3-3.068 3Zm0-4.8c-1.018 0-1.84.804-1.84 1.8s.822 1.8 1.84 1.8c1.019 0 1.841-.804 1.841-1.8s-.822-1.8-1.84-1.8Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.783 0h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
)
export default ViewIcon
